<template>
  <span id="plans" v-if="unitPeriod">

    <!-- <div id="plan-credits">
      <span class="ds-main ds-color bs-border-color">{{credits}} Credit Hours</span>
    </div> -->

    <!-- Tabs for Available Plans -->
    <div id="plan-tabs">
      <ul v-if="plans.length > 1">
        <li
          v-for="(plan, index) in plans"
          class="ds-main ds-color ds-border-color plan-tab"
          :class="{inactive: activePlan != plan}"
          :key="plan.id"
          @click="activePlanIndex = index, expand = false"
        >
          <div class = 'plan-tab-name'>{{plan.plan.name}}</div>
        </li>
      </ul>
    </div>
    <div class="plan-notes" :class="{infocollapse: setCollapse}" v-if="planNotes && planNotes.length > 0">

      <ul class="fa-ul">
        <li v-for="note in planNotes" :key="note.id">
          <span class="fa-li"><i class="fas fa-sticky-note" aria-hidden="true"></i></span>
          <div>{{note.note}}</div>

        </li>
      </ul>
      <div class="plan-notes-button">
        <div v-show="!expand" class = 'ellipsis' @click = 'setExpand'>
          <i  class = 'fa fa-angle-double-down' ></i>
        </div>
        <div v-show="expand" class = 'ellipsis' @click = 'setCollapseBack'>
          <i  class = 'fa fa-angle-double-up' ></i>
        </div>
      </div>
    </div>
    <!-- <div class='plan-notes'>
      hello
    </div> -->
    <div class = 'plan-types'>
      <div
        class = 'plan-type ds-main ds-color'
        v-for = 'pt in planTypes'
        @click = 'selectedPlanType = pt'
        :class = '{selected: selectedPlanType === pt, "ds-background": selectedPlanType === pt}'
        :key = 'pt[0]'
      >
        <i class = 'fas' :class = 'pt[1]'></i>
        <span>{{ pt[0] }}</span>
      </div>
    </div>
    <!-- Selected Plan -->
    <transition name="up-down" mode="out-in">
      <template v-for="plan in plans">
        <component
          :is="selectedPlanType[0]"
          :termIdentifier = 'termIdentifier'
          v-if="activePlan === plan"
          :key="plan.id"
          :terms="formatTerms(plan.plan_terms)"
          :special-requirements="specialRequirements"
        >
        </component>
      </template>
    </transition>
  </span>
</template>

<script>
  import {Plan, Graph, Grid, formatTerms} from '@idi/vue-degree-plan'
  import {sortBy, get, keyBy} from 'lodash'
  // import http from '../http'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'UnitPlans',

    data() {
      const planTypes = [['Plan', 'fa-list'], ['Grid', 'fa-th'], ['Graph', 'fa-share-alt']]
      return {
        // unit: null,
        activePlanIndex: 0,
        selectedPlanType: planTypes[0],
        planTypes: planTypes,
        formatTerms: formatTerms,
        expand: false,
        specialRequirementConfigs: {}
      }
    },

    watch: {
      specialRequirements(sr) {
        // this.specialRequirementConfigs = sr.map(sr => {
        //   return {
        //     id: sr.id,
        //     req: sr,
        //     selectedMinor: null,
        //     selectedSecondMajor: null,
        //     locked: false
        //     // minorOptions: (sr.minors_map || [])
        //     //   .map(minor => {
        //     //     return this.layouts.find(unit => {
        //     //       return unit.university_layout_id === minor.university_layout_id
        //     //     })
        //     //   })
        //     //   .filter(minor => minor),
        //     // secondMajorOptions: (sr.second_majors_map || [])
        //     //   .map(major => {
        //     //     return this.layouts.find(unit => {
        //     //       return unit.university_layout_id === major.university_layout_id
        //     //     })
        //     //   })
        //     //   .filter(major => major)
        //   }
        // })
      }
    },

    computed: {
      ...mapGetters(['termIdentifier', 'unitMajor', 'currentMajors']),
      ...mapState(['unitPeriod', 'layouts']),

      specialRequirements() {
        return keyBy(get(this.unitMajor, 'special_requirements', []).map(r => {
          return { requirement: r }
        }), r => r.requirement.id)
      },

      // specialRequirementsConfig() {
      //   return this.specialRequirements.map(sr => {
      //     return {

      //     }
      //   })
      // },

      selectedTermItem: {
        get() {
          return this.$store.state.selectedTermItem
        },
        set(item) {
          this.$store.commit('setSelectedTermItem', item)
        }
      },

      setCollapse() {
        if (this.expand === true) {
          return false
        } else {
          return true
        }
      },

      name() {
        return this.unitPeriod[this.unitPeriod.type].name
      },

      college() {
        return this.unitPeriod.college.name
      },

      // major() {
      //   return this.unitPeriod.period_degree_joins.filter(pdj => pdj.degree_type.code === 'MAJOR')
      // },

      credits() {
        return this.unitMajor.total_credit_hours
        // return this.unitPeriod.setperiod_degree_joins[0].total_credit_hours
      },

      plans() {
        return this.unitMajor.plan_period_joins.sort((a, b) => {
          return a.plan.plan_type.code === 'DEFAULT' ? -1 : b.plan.plan_type.code === 'DEFAULT' ? 1 : 0
        })
      },

      planNotes() {
        return this.unitMajor.plan_period_joins[this.activePlanIndex].plan.plan_notes
      },

      activePlan() {
        return this.plans[this.activePlanIndex]
      }
    },

    methods: {
      sortTerms(terms) {
        return sortBy(terms, 'position')
      },

      setExpand() {
        this.expand = true
      },
      setCollapseBack() {
        this.expand = false
      }
      // setCorrectPeriodDegreeJoin(periodDegreeJoins) {
      //   return periodDegreeJoins.filter(x => x.degree_type.code == 'MAJOR')
      // }
    },

    components: {
      Plan,
      Graph,
      Grid
    }
  }
</script>



// WEBPACK FOOTER //
// UnitPlans.vue?e6c714b6